import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIRibbon from 'UIComponents/ribbon/UIRibbon';
import H2 from 'UIComponents/elements/headings/H2';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { Flex } from 'foundations-components/components/Flex';
import { trackInsightsInteraction } from 'messaging-publishing-lib/utils/tracking';
import { INSIGHT_LISTING_PANEL_TAB } from 'messaging-publishing-lib/Insights/constant';
import { TInsightIcon } from '../EmailInsights/InsightIcon';
import InsightsList from './InsightsList';
import InsightsListFooter from './InsightsListFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AllInsightsPanel({
  topPositiveSpotlightsPaginated,
  topNegativeSpotlightsPaginated,
  positiveSpotlightCount,
  negativeSpotlightCount,
  closeInsightsPanel,
  context
}) {
  var _topNegativeSpotlight, _topPositiveSpotlight;
  const defaultSelected = !negativeSpotlightCount && positiveSpotlightCount ? INSIGHT_LISTING_PANEL_TAB.DOING_GOOD : INSIGHT_LISTING_PANEL_TAB.TO_IMPROVE;
  return /*#__PURE__*/_jsxs(UIPanel, {
    "data-test-id": "insights-list",
    width: 500,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-test-id": "close-insights-list-panel-button",
      onClick: () => {
        trackInsightsInteraction({
          action: 'close-insights-panel'
        });
        closeInsightsPanel();
      }
    }), /*#__PURE__*/_jsxs(UIPanelHeader, {
      children: [/*#__PURE__*/_jsx(UIRibbon, {
        position: "left",
        use: "beta",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-publishing.badges.beta"
        })
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.allInsights.title"
        })
      })]
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: /*#__PURE__*/_jsxs(Tabs, {
        defaultSelected: defaultSelected,
        fill: true,
        panelStyles: {
          padding: '0'
        },
        onSelectedChange: id => {
          trackInsightsInteraction({
            action: 'change-insights-tab',
            insightsTab: id
          });
        },
        children: [/*#__PURE__*/_jsx(Tab, {
          tabId: INSIGHT_LISTING_PANEL_TAB.TO_IMPROVE,
          title: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "100",
            children: [/*#__PURE__*/_jsx(TInsightIcon, {
              polarity: false,
              marginInlineEnd: "100"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "messaging-insights.insights.panel.negative.heading"
            }), "(", negativeSpotlightCount, ")"]
          }),
          children: /*#__PURE__*/_jsx(InsightsList, {
            context: context,
            insights: (_topNegativeSpotlight = topNegativeSpotlightsPaginated.data) === null || _topNegativeSpotlight === void 0 ? void 0 : _topNegativeSpotlight.spotlights,
            error: !!topNegativeSpotlightsPaginated.error,
            footer: /*#__PURE__*/_jsx(InsightsListFooter, Object.assign({}, topNegativeSpotlightsPaginated))
          })
        }), /*#__PURE__*/_jsx(Tab, {
          tabId: INSIGHT_LISTING_PANEL_TAB.DOING_GOOD,
          title: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "100",
            children: [/*#__PURE__*/_jsx(TInsightIcon, {
              polarity: true,
              marginInlineEnd: "100"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "messaging-insights.insights.panel.positive.heading"
            }), "(", positiveSpotlightCount, ")"]
          }),
          children: /*#__PURE__*/_jsx(InsightsList, {
            context: context,
            insights: (_topPositiveSpotlight = topPositiveSpotlightsPaginated.data) === null || _topPositiveSpotlight === void 0 ? void 0 : _topPositiveSpotlight.spotlights,
            error: !!topPositiveSpotlightsPaginated.error,
            footer: /*#__PURE__*/_jsx(InsightsListFooter, Object.assign({}, topPositiveSpotlightsPaginated))
          })
        })]
      })
    })]
  });
}
export default AllInsightsPanel;